/* eslint-disable react/forbid-prop-types */
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { ActivityContext } from '@bingads-webui-react/instrumentation-context';

export const withActivityContext = (WrappedComponent) => {
  const HoC = props => (
    <ActivityContext.Consumer>
      {context => (<WrappedComponent
        {...props}
        activity={context}
      />)}
    </ActivityContext.Consumer>
  );

  HoC.displayName = `withActivityContext(${getDisplayName(WrappedComponent)})`;

  return hoistNonReactStatics(HoC, WrappedComponent);
};
